import React from 'react';
import { Personnel } from '../liveTrackingTypes';
import { PersonnelCard } from './PersonnelCard';
import styles from './FieldPersonnelList.module.css';

interface FieldPersonnelListProps {
  items: Personnel[];
  onlineCount: number;
  offlineCount: number;
}

export const FieldPersonnelList: React.FC<FieldPersonnelListProps> = ({
  items, onlineCount, offlineCount,
}) => (
  <div className={styles.panel}>
    {/* Panel header */}
    <div className={styles.header}>
      <span className={styles.title}>Field Personnel</span>
      <div className={styles.badges}>
        <span className={styles.onlineBadge}>· {onlineCount} Online</span>
        <span className={styles.offlineBadge}>· {offlineCount} Offline</span>
      </div>
    </div>

    {/* List */}
    <div className={styles.list}>
      {items.map((p, idx) => (
        <PersonnelCard key={idx} person={p} />
      ))}
    </div>
  </div>
);
